import * as React from "react";
import Button from "../../Button";
import {
  ChevronArrowRight,
  CrossIcon,
  InvoiceIcon,
  InformationIcon,
  SettingIcon,
  LogOutIcon,
  ProfileIcon,
  AddCircle,
} from "../../icons";
import Menu from "../Menu";
import { signOut } from '../../../features/auth/authSlice';
import "./index.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import colors from "react-multi-date-picker/plugins/colors";

const UserMenuTile = ({ icon, title, onClick, trailing = true, style }) => {
  return (
    <button className={"user-menu-tile"} onClick={onClick} style={style}>
      {icon}
      <div className="user-menu-title">
        {title}
      </div>

      <ChevronArrowRight
        fill={"rgba(0, 0, 0, 0)"}
        size={15}
        stroke={trailing ? "#4C4A4F" : "#ffffff00"}
        className={""}
      />
    </button>
  );
};

const UserMenu = ({ isOpen, setIsOpen, setOpenModal }) => {

  const dispatch = useDispatch();

  const onClose = () => {
    setIsOpen(false);
  }

  const userMenuTileData = [
    // {
    //   icon: (
    //     <InformationIcon
    //       className={"user-menu-icon"}
    //       size={25}
    //       stroke={"#4C4A4F"}
    //       fill={"rgba(0, 0, 0, 0)"}
    //     />
    //   ),
    //   title: "Contact Information",
    //   onClick: console.log("Contact Information"),
    //   id: "contact-info",
    // },
    {
      icon: (
        <InformationIcon
          className={"user-menu-icon"}
          size={25}
          stroke={"#4C4A4F"}
          fill={"rgba(0, 0, 0, 0)"}
        />
      ),
      title: "Payment Information",
      id: "payment-info",
    },
    {
      icon: (
        <InvoiceIcon
          className={"user-menu-icon"}
          size={25}
          stroke={"#4C4A4F"}
          fill={"rgba(0, 0, 0, 0)"}
        />
      ),
      title: "Transaction Receipts",
      id: "tx-rec",
    },
    {
      icon: (
        <SettingIcon
          className={"user-menu-icon"}
          size={25}
          stroke={"#4C4A4F"}
          fill={"rgba(0, 0, 0, 0)"}
        />
      ),
      title: "Change password",
      id: "change-pass",
    },
  ];

  const navigate = useNavigate();
  return (
    <>
      <Menu
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className={"user-menu"}
        title={"User Menu"}
        backgroundColor={"rgba(246, 245, 247, 1)"}
      >
        <div className="user-menu-base">
          <div className="user-menu-header">
            <span>User Profile</span>
            <CrossIcon
              onClick={() => setIsOpen(false)}
              size={20}
              className={"user-menu-icon sm"}
            />
          </div>
          <div className="user-menu-body">
            <UserMenuTile
              icon={
                <ProfileIcon
                  size={25}
                  stroke={"#4C4A4F"}
                  fill={"rgba(0, 0, 0, 0)"}
                  className={"user-menu-icon"}
                />
              }
              title={"Dashboard"}
              onClick={() => {
                navigate("/dashboard");
                setIsOpen(false);
              }}
            />
            {userMenuTileData.map((tile) => (
              <UserMenuTile
                {...tile}
                onClick={() => {
                  setIsOpen(false);
                  setOpenModal(tile.id);
                }}
              />
            ))}
            <UserMenuTile
              icon={<AddCircle fill={"rgba(0, 0, 0, 0)"} stroke={"white"} className='user-menu-icon'/>}
              id={"contact-info"}
              title={"Post Classified"}
              trailing={false}
              style={{
                backgroundColor: "var(--red)",
                color: "white",
              }}
              onClick={() => {
                navigate("/submit");
                setIsOpen(false);
              }}
            />
            <div className={"user-menu-logout"}
              onClick={() => {
                dispatch(signOut())
                setIsOpen(false);
                navigate("/");
                localStorage.removeItem("classified");
                localStorage.removeItem("facilities");
                localStorage.removeItem("amenities");
              }}>
              <LogOutIcon
                size={25}
                fill={"rgba(0, 0, 0, 0)"}
                className={"user-menu-icon"}
              />
              Logout
            </div>
          </div>
        </div>
      </Menu>
    </>
  );
};

export default UserMenu;
